'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { useContentVisibleEvent } from 'hooks/analytics/use-content-visible-event';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { instances } from '../../types';
import { useGaEventContext } from '../../_components/customer-account/gaevent-context-provider';

const useServiceInsightGaEvent = ({
  serviceInsights,
  viewAllmodal
}: Readonly<{
  serviceInsights: Array<instances>;
  viewAllmodal: boolean;
}>) => {
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const t = useTranslations();
  const { fireContentVisibleEvent } = useContentVisibleEvent();
  const { handleGaEventCapture, gaEventCaptured } = useGaEventContext();

  useEffect(() => {
    const handleVisibleGaEvent = (row) => {
      const contentVisibleGaEventDetails = {
        contentType: 'content',
        contentLocation: isDesktop === false && viewAllmodal ? 'modal' : 'body'
      };

      const {
        payload: { title = '' },
        equipmentInfo: {
          productFamily = '',
          model = '',
          serialNumber = '',
          assetName = ''
        }
      } = row;

      const equipmentSerial = serialNumber ? ` | ${serialNumber}` : '';
      const nickName = assetName ? `${assetName} | ` : '';
      const equipmentName = `${t('SERVICE_RECOMMENDATIONS')} : ${nickName}${model}${productFamily}${equipmentSerial}`;

      fireContentVisibleEvent({
        ...contentVisibleGaEventDetails,
        contentName: equipmentName,
        contentDescription: title
      });
    };
    if (
      gaEventCaptured['serviceRecommendation'] &&
      serviceInsights &&
      (isDesktop || (isDesktop === false && viewAllmodal))
    ) {
      serviceInsights.forEach((row) => {
        handleVisibleGaEvent(row);
      });
      handleGaEventCapture('serviceRecommendation', false);
    } else if (
      isDesktop === false &&
      serviceInsights &&
      gaEventCaptured['serviceRecommendation']
    ) {
      serviceInsights.slice(0, 2).forEach((row) => {
        handleVisibleGaEvent(row);
      });
      handleGaEventCapture('serviceRecommendation', false);
    }
  }, [
    serviceInsights,
    isDesktop,
    viewAllmodal,
    gaEventCaptured,
    fireContentVisibleEvent,
    handleGaEventCapture,
    t
  ]);
};

export default useServiceInsightGaEvent;
